import { yupResolver } from '@hookform/resolvers/yup';
import { useSelector } from 'react-redux';
import * as Yup from 'yup';
import Button from '@/components/UI/Button';
import { HookForm } from '@/components/UI/HookForm/Form';
import { HookReactSingleSelect } from '@/components/UI/HookForm/Form/ReactSelect';
import { HookFormProvider } from '@/components/UI/HookForm/Provider';
import { authSelector } from '../../../store';

interface ChangeAccountFormProps {
  handleModal: () => void;
}

export default function ChangeAccountForm({ handleModal }: ChangeAccountFormProps) {
  const auth = useSelector(authSelector);

  const validationSchema = Yup.object({
    account: Yup.object({
      label: Yup.string(),
      value: Yup.string(),
    }).test('account', 'Required', (val) => {
      return val.label !== undefined && val.value !== undefined;
    }),
  });

  const accountSubmitHandler = (formData: any) => {
    const account = formData.account.value;
    if (localStorage.getItem('xSubdomain') !== account) {
      localStorage.setItem('xSubdomain', account);
      window.location.href = '/';
    } else {
      handleModal();
    }
  };

  return (
    <HookFormProvider resolver={yupResolver(validationSchema)} mode='all'>
      <HookForm onSubmit={accountSubmitHandler}>
        <h2 className='text-primaryColor-normal mt-0'>Switch Account</h2>
        <section className='space-y-5'>
          <HookReactSingleSelect
            defaultValue={auth.data.membership
              .map((m) => ({ label: m.name, value: m.subdomain }))
              .find((m) => m.value === auth.currentDomain)}
            name='account'
            componentClassName='grid justify-items-stretch'
            options={auth.data.membership.map((m) => ({
              label: m.name,
              value: m.subdomain,
            }))}
          />
          <div className='flex flex-row mt-8 w-full justify-end items-center space-x-5'>
            <Button label='Cancel' btnStyle='btn-neutral' btnType='button' onClick={handleModal} />
            <Button label='Switch' btnStyle='btn-primary' btnType='Submit' />
          </div>
        </section>
      </HookForm>
    </HookFormProvider>
  );
}
